import { create } from 'zustand'

/**
 * Holds the AssistantChat open/closed state above the HomePage route, so
 * navigating away (e.g. into the composer) and back doesn't snap it shut.
 *
 * In-memory only — a full page reload still resets it to closed, which
 * matches the prior useState behavior.
 */
interface AssistantChatUIState {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useAssistantChatUIStore = create<AssistantChatUIState>(set => ({
  open: false,
  setOpen: open => set({ open }),
}))
